import styleInject from './../../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".SepaForm-module_margin__JV3gT {\n  margin-bottom: var(--pp-spacing-m);\n}\n\n.SepaForm-module_formMessageContainer__VeEap {\n  display: flex;\n  flex-direction: column;\n  row-gap: 10px;\n}\n@media (min-width: 544px) {\n  .SepaForm-module_formMessageContainer__VeEap {\n    flex-direction: row;\n    row-gap: 0;\n  }\n}\n\n.SepaForm-module_formMessage__3pYBM {\n  flex: 1;\n}";
var styles = {"margin":"SepaForm-module_margin__JV3gT","formMessageContainer":"SepaForm-module_formMessageContainer__VeEap","formMessage":"SepaForm-module_formMessage__3pYBM"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=SepaForm.module.scss.js.map
